import { RouteComponentProps } from "@reach/router";
import { FunctionComponent, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../shared/ErrorFallback";

interface IProps extends RouteComponentProps {
	loading: React.ReactElement;
}

const LazyKitahara = lazy(() => import(/* webpackChunkName: "Kitahara" */ "./Kitahara"));

const KitaharaPage: FunctionComponent<IProps> = (props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { path, loading } = props;

	return <ErrorBoundary FallbackComponent={ErrorFallback}>
		<LazyKitahara loading={loading} />
	</ErrorBoundary>;
};

export default KitaharaPage;